/**
 * Please use customEmotion for all emotion related imports due to the nonce issue.
 * Reference:
 * https://emotion.sh/docs/@emotion/cache#nonce
 * https://emotion.sh/docs/@emotion/css#multiple-instances-in-a-single-app-example
 */

import createEmotion from 'create-emotion';

/**
 * Like the way JSS fetch nonce from meta tag.
 * (ref.: https://github.com/cssinjs/jss/blob/master/docs/csp.md)
 * @returns nonce if it exists, otherwise undefined
 */
const getNonce = () => {
  const cspMeta =
    document && document.querySelector("meta[property='csp-nonce']");
  const nonce = cspMeta && cspMeta.getAttribute('content');
  return nonce ? nonce : undefined;
};

export const {
  flush,
  hydrate,
  cx,
  merge,
  getRegisteredStyles,
  injectGlobal,
  keyframes,
  css,
  sheet,
  cache,
} = createEmotion({
  nonce: getNonce(),
});
